import { render, staticRenderFns } from "./Lv1Delivery.vue?vue&type=template&id=779c4c12"
import script from "./Lv1Delivery.vue?vue&type=script&lang=js"
export * from "./Lv1Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports